<app-investment-asset-list [type]="1"></app-investment-asset-list>
